import { Stack } from '@mantine/core'
import { createFileRoute } from '@tanstack/react-router'
import ShortageOrderTable from 'components/shortage/ShortageOrderTable'
import { manufacturersQueryOptions } from 'hooks/products'
import { shortageOrdersQuery } from 'hooks/shortage'
import { usersQuery } from 'hooks/users'
import { Account } from 'types/auth'
import { Manufacturer } from 'types/products'

export const Route = createFileRoute('/_auth/_admin/shortages/orders')({
  loader: async ({ context: { queryClient } }) => {
    return await Promise.all([
      await queryClient.ensureQueryData(usersQuery),
      await queryClient.ensureQueryData(manufacturersQueryOptions),
      await queryClient.ensureQueryData(
        shortageOrdersQuery({
          columnFilters: [],
          pagination: { pageIndex: 0, pageSize: 10 },
        })
      ),
    ])
  },
  component: RouteComponent,
})

function RouteComponent() {
  const loaderData = Route.useLoaderData()
  const users = loaderData[0] as Array<Account>
  const manufacturers = loaderData[1] as Array<Manufacturer>

  return (
    <Stack mt="xl">
      <ShortageOrderTable users={users} manufacturers={manufacturers} />
    </Stack>
  )
}
